module.exports = __webpack_public_path__ + "img/sabiba-logo.eafd7f57.png";